export function getAnimationKeyframes(offsetWidth: number): Keyframe[] {
  return [
    { offset: 0, transform: 'translateX(0)' },
    { offset: 0.2, transform: 'translateX(0)' },
    { offset: 0.8, transform: `translateX(${offsetWidth}px)` },
    { offset: 1, transform: `translateX(${offsetWidth}px)` },
  ];
}
